import { render, staticRenderFns } from "./Saas.vue?vue&type=template&id=56f1312c&"
import script from "./Saas.vue?vue&type=script&lang=js&"
export * from "./Saas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports